import {Component, OnInit} from '@angular/core';
import {ApiService} from '../shared/api.service';
import {SlideshowService} from '../slideshow/slideshow.service';
import { PermissionsService } from '../shared/permissions.service';
import { Permissions } from '../shared/permissions.enum';

@Component({
    selector: 'msn-fields-component',
    templateUrl: 'msn-fields.component.html'
})
export class MsnFieldsComponent implements OnInit {
    msnFields = [];
    user;
    userCanEdit;

    constructor(
        private api: ApiService,
        public slideshow: SlideshowService,
        public permissionsService: PermissionsService,
    ) {
        let user = api.getProp('user');
        this.user = user;
        this.userCanEdit = permissionsService.userHasPermission(Permissions.EditMSNFields);
    }

    ngOnInit() {
        this.msnFields = JSON.parse(JSON.stringify(this.slideshow.assignment?.msnFields));
    }

    onOptionChange(field, newOption) {
        field.selectedOption = newOption;
        this.slideshow.assignment.msnFields = JSON.parse(JSON.stringify(this.msnFields));
    }
}